import { JSX } from 'react'
import { Quote } from '~/config/quotes'
import { QuoteBlock } from './quote-block'
import { QuoteBlockv2 } from './quote-block-v2'

import clsx from 'clsx'

type QuoteBlockProps = {
  quote: Quote
  className?: string
  partnerText?: JSX.Element
  balanced?: boolean
  ctaUnderQuote?: boolean
  alignQuote?: string
  hideCta?: boolean
  mobileCtaAfterQuote?: boolean
  partnerFirst?: boolean
}

export const QuoteSection = ({ quote, className }: QuoteBlockProps) => {
  return (
    <section className={clsx(['quote-section', className])}>
      <div className="dot-texture"></div>
      <div className="dot-texture"></div>
      <QuoteBlock quote={quote} />
    </section>
  )
}

export const QuoteSectionv2 = ({
  quote,
  className,
  partnerText,
  ctaUnderQuote,
  alignQuote,
  hideCta,
  mobileCtaAfterQuote,
  partnerFirst,
}: QuoteBlockProps) => {
  return (
    <section className={clsx(['quote-section-v2', className])}>
      <QuoteBlockv2
        quote={quote}
        partnerText={partnerText}
        ctaUnderQuote={ctaUnderQuote}
        alignQuote={alignQuote}
        hideCta={hideCta}
        mobileCtaAfterQuote={mobileCtaAfterQuote}
        partnerFirst={partnerFirst}
      />
    </section>
  )
}

export const QuoteSectionv3 = ({ quote, className }: QuoteBlockProps) => {
  return (
    <section className={clsx(['quote-section-v3', className])}>
      <div className="dot-texture"></div>
      <div className="dot-texture"></div>
      <QuoteBlock hideCta quote={quote} />
    </section>
  )
}
